import { BreadcrumbStyles } from './styles/Breadcrumb.styles';
import { CheckStyles, DetailsRowStyles, DetailsHeaderStyles, DetailsRowCheckStyles } from './styles/DetailsList.styles';
import { CalloutContentStyles } from './styles/Callout.styles';
import { CheckboxStyles } from './styles/Checkbox.styles';
import { ChoiceGroupOptionStyles } from './styles/ChoiceGroupOption.styles';
import { ColorPickerStyles, ColorRectangleStyles, ColorSliderStyles } from './styles/ColorPicker.styles';
import { ComboBoxStyles } from './styles/ComboBox.styles';
import { CommandBarStyles } from './styles/CommandBar.styles';
import { CommandBarButtonStyles } from './styles/CommandBarButton.styles';
import { CompoundButtonStyles } from './styles/CompoundButton.styles';
import { ContextualMenuStyles } from './styles/ContextualMenu.styles';
import { DefaultButtonStyles } from './styles/DefaultButton.styles';
import { DetailsColumnStyles } from './styles/DetailsColumn.styles';
import { DialogContentStyles, DialogFooterStyles } from './styles/Dialog.styles';
import { DropdownStyles } from './styles/Dropdown.styles';
import { ExpandingCardStyles, PlainCardStyles } from './styles/HoverCard.styles';
import { FacepileStyles } from './styles/Facepile.styles';
import { GroupHeaderStyles } from './styles/GroupedList.styles';
import { IconButtonStyles } from './styles/IconButton.styles';
import { LabelStyles } from './styles/Label.styles';
import { LinkStyles } from './styles/Link.styles';
import { MessageBarStyles } from './styles/MessageBar.styles';
import { MessageBarButtonStyles } from './styles/MessageBarButton.styles';
import { NavStyles } from './styles/Nav.styles';
import { PanelStyles } from './styles/Panel.styles';
import { PersonaStyles, PersonaCoinStyles } from './styles/Persona.styles';
import { PivotStyles } from './styles/Pivot.styles';
import { PrimaryButtonStyles } from './styles/PrimaryButton.styles';
import { SliderStyles } from './styles/Slider.styles';
import { SpinButtonStyles } from './styles/SpinButton.styles';
import { TeachingBubbleStyles } from './styles/TeachingBubble.styles';
import { TextFieldStyles } from './styles/TextField.styles';
import { ToggleStyles } from './styles/Toggle.styles';

// Roll up all style overrides in a single "Fluent theme" object

export const MDL2Styles = {
  Breadcrumb: {
    styles: BreadcrumbStyles,
  },
  CalloutContent: {
    styles: CalloutContentStyles,
  },
  ColorPicker: {
    styles: ColorPickerStyles,
  },
  ColorRectangle: {
    styles: ColorRectangleStyles,
  },
  ColorSlider: {
    styles: ColorSliderStyles,
  },
  CommandBar: {
    styles: CommandBarStyles,
  },
  CommandBarButton: {
    styles: CommandBarButtonStyles,
  },
  CompoundButton: {
    styles: CompoundButtonStyles,
  },
  Check: {
    styles: CheckStyles,
  },
  Checkbox: {
    styles: CheckboxStyles,
  },
  ChoiceGroupOption: {
    styles: ChoiceGroupOptionStyles,
  },
  ComboBox: {
    styles: ComboBoxStyles,
  },
  ContextualMenu: {
    styles: ContextualMenuStyles,
  },
  DefaultButton: {
    styles: DefaultButtonStyles,
  },
  DetailsColumn: {
    styles: DetailsColumnStyles,
  },
  DetailsHeader: {
    styles: DetailsHeaderStyles,
  },
  DetailsRow: {
    styles: DetailsRowStyles,
  },
  DetailsRowCheck: {
    styles: DetailsRowCheckStyles,
  },
  DialogContent: {
    styles: DialogContentStyles,
  },
  DialogFooter: {
    styles: DialogFooterStyles,
  },
  Dropdown: {
    styles: DropdownStyles,
  },
  ExpandingCard: {
    styles: ExpandingCardStyles,
  },
  Facepile: {
    styles: FacepileStyles,
  },
  GroupHeader: {
    styles: GroupHeaderStyles,
  },
  IconButton: {
    styles: IconButtonStyles,
  },
  Label: {
    styles: LabelStyles,
  },
  Link: {
    styles: LinkStyles,
  },
  MessageBar: {
    styles: MessageBarStyles,
  },
  MessageBarButton: {
    styles: MessageBarButtonStyles,
  },
  Nav: {
    styles: NavStyles,
  },
  Panel: {
    styles: PanelStyles,
  },
  Persona: {
    styles: PersonaStyles,
  },
  PersonaCoin: {
    styles: PersonaCoinStyles,
  },
  Pivot: {
    styles: PivotStyles,
  },
  PlainCard: {
    styles: PlainCardStyles,
  },
  PrimaryButton: {
    styles: PrimaryButtonStyles,
  },
  Slider: {
    styles: SliderStyles,
  },
  SpinButton: {
    styles: SpinButtonStyles,
  },
  TeachingBubble: {
    styles: TeachingBubbleStyles,
  },
  TeachingBubbleContent: {
    styles: TeachingBubbleStyles,
  },
  TextField: {
    styles: TextFieldStyles,
  },
  Toggle: {
    styles: ToggleStyles,
  },
};
